export default __webpack_public_path__ + "static/media/visual-animation.15e95f54.png";